module.exports = "<h1>Orders</h1>\n<table class=\"table\">\n  <thead>\n    <tr>\n      <th>Customer</th>\n      <th>Date</th>\n      <th></th>\n    </tr>\n  </thead> \n  <tbody>\n    <tr *ngFor=\"let order of orders$ | async\">\n      <td>{{ order.shipping.name }}</td>\n      <td>{{ order.datePlaced | date}}</td>\n      <td>\n        <a href=\"#\">View</a>\n      </td>\n    </tr>\n  </tbody> \n</table>"


//////////////////
// WEBPACK FOOTER
// C:/dev1/Aladin-SHOP/src/app/shopping/components/my-orders/my-orders.component.html
// module id = ../../../../../src/app/shopping/components/my-orders/my-orders.component.html
// module chunks = main